module.exports = __webpack_public_path__ + "fonts/1863a0b83fedb2964d584ef86ba279ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/excess.svg
// module id = 2080
// module chunks = 0